import { useInstance } from 'intact-vue';
import { inArray } from './useChecked';
import { toggleArray } from '../utils';
export function useSelected() {
  var instance = useInstance();
  function isSelected(key) {
    return inArray(instance.get('selectedKeys'), key);
  }
  instance.on('clickRow', function (data, index, key) {
    var _instance$get = instance.get(),
      rowSelectable = _instance$get.rowSelectable,
      selectedKeys = _instance$get.selectedKeys;
    if (rowSelectable === 'multiple') {
      instance.set('selectedKeys', toggleArray(selectedKeys, key));
    } else if (rowSelectable) {
      if (!selectedKeys || selectedKeys[0] !== key) {
        instance.set('selectedKeys', [key]);
      } else {
        instance.set('selectedKeys', []);
      }
    }
  });
  return {
    isSelected: isSelected
  };
}